import React from "react";
import MyIcon from "../MyIcon";
import { Spinner } from "react-bootstrap";
import APICredentialsIcon from "../../../assets/icons/api_cog-01.svg2";

export default function ApiWaitingForData() {
  return (
    <div className=" align-items-center rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker-reverse m-3">
      <div className="d-flex flex-column align-items-center">
        <div>
          <MyIcon Icon={APICredentialsIcon} width={30} className="me-2" />
        </div>
        <div className="fw-bold ">Waiting for data</div>
        <div className="small opacity-50">
          Lorem ipsum dolor sit amet consectetur adipisicing elit.
        </div>
        <Spinner
          animation="border"
          role="status"
          className="mt-4 text-purple "
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    </div>
  );
}
